import {createRouter, createWebHistory} from 'vue-router'
import FrontView from '../views/FrontView.vue'
import IndexView from '../views/IndexView.vue'

const routes = [
    {
        path: '/index',
        name: 'font',
        component: FrontView
    },
    {
        path: '/',
        name: 'index',
        component: IndexView
    },
    {
        path: '/brand/:id',
        name: 'brand',
        component: () => import('../views/BrandView.vue'),
        props: true
    },
    {
        path: '/team',
        name: 'team',
        component: () => import('../views/TeamView.vue')
    },
    {
        path: '/goods',
        name: 'goods',
        component: () => import('../views/ProductView.vue')
    },
    {
        path: '/good',
        name: 'good',
        component: () => import('../views/ProductView.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('../views/NotFound.vue')
    }
]


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
